import { Button } from "../components/ui/button";
import { Link } from "wouter";

export default function NotFound() {
  return (
    <div className="container flex flex-col items-center justify-center py-16 text-center">
      <h1 className="text-6xl font-display font-bold mb-4 text-primary">404</h1>
      <h2 className="text-2xl font-bold mb-2">Page Not Found</h2>
      <p className="text-muted-foreground mb-8 max-w-md">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link to="/">
        <Button className="bg-primary hover:bg-primary/90 text-primary-foreground">
          Go Home
        </Button>
      </Link>
    </div>
  );
}